'use client';

import { createContext, useContext } from 'react';

export const TurnstileContext = createContext(null);

/**
 * Hook за достъп до Turnstile: токен и reset.
 * Токенът се използва при изпращане на форми/заявки; след употреба извиквай resetTurnstile().
 */
export function useTurnstile() {
  const ctx = useContext(TurnstileContext);
  return ctx;
}
